import { render, staticRenderFns } from "./MultiUnitProp.vue?vue&type=template&id=04a9bdd3&scoped=true"
import script from "./MultiUnitProp.vue?vue&type=script&lang=js"
export * from "./MultiUnitProp.vue?vue&type=script&lang=js"
import style0 from "./MultiUnitProp.vue?vue&type=style&index=0&id=04a9bdd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a9bdd3",
  null
  
)

export default component.exports